import React, { useState } from 'react';
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonCol, IonContent, IonGrid, IonHeader, IonImg, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonSegment, IonSegmentButton, IonText, IonTitle, IonToolbar } from '@ionic/react';
import ExploreContainer from './ExploreContainer';
import { dataJSON } from '../data';

type Params = {
  modulData?: any;

};

export const Fragen: React.FC<Params> = ({ modulData }) => {
 const [antwort1, setAntwort1] = useState(false);
    const [antwort2, setAntwort2] = useState(false);
    const [antwort3, setAntwort3] = useState(false);
    const [antwort4, setAntwort4] = useState(false);
    const [antwort5, setAntwort5] = useState(false);
    const [antwort6, setAntwort6] = useState(false);
    const [loesungAnzeigen, setLoesungAnzeigen] = useState(false);

      const [antwort1farbe, setAntwort1farbe] = useState("none");
    const [antwort2farbe, setAntwort2farbe] = useState("none");
    const [antwort3farbe, setAntwort3farbe] = useState("none");
    const [antwort4farbe, setAntwort4farbe] = useState("none");
    const [antwort5farbe, setAntwort5farbe] = useState("none");
    const [antwort6farbe, setAntwort6farbe] = useState("none");

function resetAnswerColors() {
  setAntwort1farbe("none");
  setAntwort2farbe("none");
  setAntwort3farbe("none");
  setAntwort4farbe("none");
  setAntwort5farbe("none");
  setAntwort6farbe("none");
}

function updateAntwort(
  setAntwort: React.Dispatch<React.SetStateAction<boolean>>,
  checked: boolean
) {
  setAntwort(checked);
  if (loesungAnzeigen) {
    setLoesungAnzeigen(false);
    resetAnswerColors();
  }
}

function checkAnswers(modulData:any){
setLoesungAnzeigen(true);
if(antwort1!==undefined){

  setAntwort1farbe(
    modulData['Richtig1']=='Ja'&&antwort1==true || modulData['Richtig1']=='Nein'&&antwort1==false
    ?"success"
    :"danger"
  );
}
if(antwort2!==undefined){

  setAntwort2farbe(
    modulData['Richtig2']=='Ja'&&antwort2==true || modulData['Richtig2']=='Nein'&&antwort2==false
    ?"success"
    :"danger"
  );
}
if(antwort3!==undefined){

  setAntwort3farbe(
    modulData['Richtig3']=='Ja'&&antwort3==true || modulData['Richtig3']=='Nein'&&antwort3==false
    ?"success"
    :"danger"
  );
}
if(antwort4!==undefined){

  setAntwort4farbe(
    modulData['Richtig4']=='Ja'&&antwort4==true || modulData['Richtig4']=='Nein'&&antwort4==false
    ?"success"
    :"danger"
  );
}
if(antwort5!==undefined){

  setAntwort5farbe(
    modulData['Richtig5']=='Ja'&&antwort5==true || modulData['Richtig5']=='Nein'&&antwort5==false
    ?"success"
    :"danger"
  );
}
if(antwort6!==undefined){

  setAntwort6farbe(
    modulData['Richtig6']=='Ja'&&antwort6==true || modulData['Richtig6']=='Nein'&&antwort6==false
    ?"success"
    :"danger"
  );
}

}

return (
  <><p>{modulData['Frage1']}  </p>
                              <IonList>
                                {modulData['Antwort1']!=null
                                ?
                               <IonItem key="Antwort1"  
                               color={antwort1farbe}>
                                  <IonCheckbox  key="checkbox1" checked={antwort1} slot="start" onIonChange={(e:any)=>updateAntwort(setAntwort1, e.detail.checked)}/>
                                  {modulData['Antwort1']}
                                  </IonItem>
                              :null}
                               {modulData['Antwort2']!=null
                                ?
                               <IonItem key="Antwort2"  color={antwort2farbe}>    
                                  <IonCheckbox  key="checkbox2" checked={antwort2} slot="start" onIonChange={(e:any)=>updateAntwort(setAntwort2, e.detail.checked)}/>{modulData['Antwort2']}</IonItem>
                              :null}
                              {modulData['Antwort3']!=null
                                ?
                                 <IonItem key="Antwort3"  color={antwort3farbe}><IonCheckbox checked={antwort3} key="checkbox3" slot="start" onIonChange={(e:any)=>updateAntwort(setAntwort3, e.detail.checked)}/>{modulData['Antwort3']}</IonItem>
                              :null}
                              {modulData['Antwort4']!=null
                                ?
                                 <IonItem key="Antwort4" color={antwort4farbe}><IonCheckbox  key="checkbox4" checked={antwort4} slot="start" onIonChange={(e:any)=>updateAntwort(setAntwort4, e.detail.checked)}/>{modulData['Antwort4']}</IonItem>
                              :null}
                              {modulData['Antwort5']!=null
                                ?
                                 <IonItem key="Antwort5"  color={antwort5farbe}><IonCheckbox  key="checkbox5" checked={antwort5} slot="start" onIonChange={(e:any)=>updateAntwort(setAntwort5, e.detail.checked)}/>{modulData['Antwort5']}</IonItem>
                              :null}
                              {modulData['Antwort6']!=null
                                ?
                                 <IonItem key="Antwort6"  color={antwort6farbe}><IonCheckbox key="checkbox6" checked={antwort6} slot="start" onIonChange={(e:any)=>updateAntwort(setAntwort6, e.detail.checked)}/>{modulData['Antwort6']}</IonItem>
                              :null}
                              </IonList>
                                <IonButton onClick={()=>{checkAnswers(modulData)}}>Lösung anzeigen.</IonButton>
</>
)
}

